export function getFormattedAddress({ line1, line2, zip, city, state, county, country }) {
  let main = add(line1, false);
  main += add(line2);

  let secondary = add(zip, false);
  secondary += add(city, !!secondary);
  secondary += add(state || county);
  secondary += add(country);

  return {
    main,
    secondary,
  };

  function add(data, commaBefore = true) {
    return data ? `${commaBefore ? ', ' : ''}${data}` : '';
  }
}



// WEBPACK FOOTER //
// ./src/utils/getFormatedAddress.js